// src/components/CustomAlert.jsx
import React from "react";
import { motion, AnimatePresence } from "framer-motion";

function CustomAlert({ show, title, message, onOK, onCancel, buttonOKText = "확인", twoButton = false, buttonCancelText = "취소" }) {
	//if (!show) return null;

	return (
		<AnimatePresence>
			{show && (
				<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
					<motion.div className="flex flex-col text-[var(--alert-text-color)] min-w-[420px] rounded-xl shadow-lg p-6 bg-[var(--alert-bg-color)] gap-[24px]"
						initial={{ opacity: 0, scale: 0.95 }}
						animate={{ opacity: 1, scale: 1 }}
						exit={{ opacity: 0, scale: 0.95 }}
						transition={{ duration: 0.2 }}
					>
						<div className="flex w-full text-[16px] items-center justify-center text-center whitespace-pre-line" dangerouslySetInnerHTML={{ __html: message }} />
						<div className="flex justify-center gap-[16px]">
							{twoButton ? (<>
								<button
									onClick={onCancel}
									className="bg-[var(--alert-two-btn-bg-color)] text-[var(--alert-two-btn-text-color)] text-[13px] min-w-[100px] p-[9px] rounded-[4px]"
								>
									{buttonCancelText}
								</button>
								<button
									onClick={onOK}
									className="bg-[var(--alert-one-btn-bg-color)] text-[var(--alert-one-btn-text-color)] text-[13px] min-w-[100px] p-[9px] rounded-[4px]"
								>
									{buttonOKText}
								</button>
							</>) : (<>
								<button
									onClick={onOK}
									className="bg-[var(--alert-one-btn-bg-color)] text-[var(--alert-one-btn-text-color)] text-[13px] min-w-[100px] p-[9px] rounded-[4px] hover:bg-blue-600"
								>
									{buttonOKText}
								</button>
							</>)}

						</div>
					</motion.div>
				</div>
			)}
		</AnimatePresence>
	);
}

export default CustomAlert;
